import _ from 'lodash';
import uuid4 from 'uuid/v4';

export const VOLATILE_KEY_PREFIX = `_volatile_`;

export const toVolatileKey = key => `${VOLATILE_KEY_PREFIX}.${key}`;

export const setLocals = (firebase, data) => {
  if (!firebase.auth().currentUser) return;
  const userId = firebase.auth().currentUser.uid;
  const localsRef = firebase.firestore().collection('locals').doc(userId);
  return localsRef.update(data).catch(e => {
    localsRef.set(data);
  });
};


export const setVolatile = (firebase, data) => {
  return setLocals(firebase, _.mapKeys(data, (v, k) => toVolatileKey(k)));
};

export const getVolatile = (locals, key, defaultValue) => {
  return _.get(locals, typeof key === 'string' ? toVolatileKey(key) : [VOLATILE_KEY_PREFIX, ...key], defaultValue);
};